import { FC } from 'react'
import { MenuItem, Stack, TextField } from '@mui/material'
import { CurrencyField } from '@/components/common/CurrencyField'
import { FonteValorImovel, ROTULO_FONTE_VALOR_IMOVEL } from '@/types/elegibilidade'

export interface ValoresImovel {
  valorImovel: number
  valorImovelFonte: FonteValorImovel
  valorSolicitado: number
}

/**
 * P2 (AN-PP2 §8, Q-PP2-4): dados declarados do Home Equity (`LTV_MAX`) — valor estimado do
 * imóvel, fonte e valor solicitado. O LTV NÃO é calculado aqui: o servidor devolve
 * `ltvCalculado` e a tela mostra como veio.
 */
export const CamposImovel: FC<{
  valores: ValoresImovel
  onChange: (v: ValoresImovel) => void
  disabled?: boolean
}> = ({ valores, onChange, disabled }) => (
  <Stack spacing={2}>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <CurrencyField
        label="Valor estimado do imóvel (R$)"
        value={valores.valorImovel}
        onChange={(v) => onChange({ ...valores, valorImovel: v })}
        fullWidth
        disabled={disabled}
      />
      <TextField
        select
        label="Fonte do valor do imóvel"
        value={valores.valorImovelFonte}
        onChange={(e) => onChange({ ...valores, valorImovelFonte: e.target.value as FonteValorImovel })}
        fullWidth
        disabled={disabled}
        SelectProps={{ inputProps: { 'aria-label': 'Fonte do valor do imóvel' } }}
      >
        {(Object.keys(ROTULO_FONTE_VALOR_IMOVEL) as FonteValorImovel[]).map((f) => (
          <MenuItem key={f} value={f}>
            {ROTULO_FONTE_VALOR_IMOVEL[f]}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
    <CurrencyField
      label="Valor solicitado (R$)"
      value={valores.valorSolicitado}
      onChange={(v) => onChange({ ...valores, valorSolicitado: v })}
      fullWidth
      disabled={disabled}
      helperText="Crédito pedido com o imóvel em garantia. O LTV é calculado pelo servidor."
    />
  </Stack>
)

export default CamposImovel
